import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '@/redux/hooks';
import { QueriesKeys } from '../queriesKeys';
import { verificationsApi } from './verifications.api';

export const useVerificationsQuery = () => {
  const { userSession } = useAppSelector(state => state.user);

  return useQuery({
    queryKey: [QueriesKeys.verifications],
    queryFn: () => verificationsApi.getAll(),
    enabled: userSession,
  });
};
